import styled from 'styled-components';

export const StyledButton = styled.button`
  position: relative;
  outline: none;
  padding: 5px 0px 5px 10px;
  font-family: var(--main-font);
  font-weight: 700 !important;
  font-size: 16px;
  color: #000 !important;
  border: 2px solid #000 !important;
  background-color: transparent !important;
  background-image: none !important;
  letter-spacing: 1px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  text-transform: capitalize !important;
  cursor: pointer;

  &:hover {
    color: #fff !important;
    border: 2px solid #000 !important;
    background-color: #000 !important;
  }

  &:focus {
    color: #8733FF;
    border-left: 10px solid #8733FF;
  }
`;

export default StyledButton
